import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import Socket from "socket";
import * as gameAction from "../../redux/game/action";
import * as loaderAction from "../../redux/loader/action";
import Playing from "./screens/Playing";
import BingoCalled from "./screens/BingoCalled";
import Over from "./screens/Over";
import HowToPlay from "./components/HowToPlay";
import Joining from "./screens/Joining";
import _ from "lodash";
import cx from "classnames";
import BadBingo from "./screens/BadBingo";
import Footer from "./components/Footer";

const Bingo = (props) => {
  const gameReducer = _.get(props, "gameReducer");
  const gameParams = _.get(props, "paramsReducer.gameObj");
  const roomObj = _.get(gameReducer, "roomObj");
  const currentUser = _.get(gameReducer, "currentUser");
  const game_state = _.get(roomObj, "game_state");
  const status = _.get(game_state, "status");
  const game_parameters = _.get(game_state, "game_parameters");
  const timed = _.get(game_parameters, "timed");
  const timer = _.get(game_parameters, "timer");
  const called_numbers = _.get(game_state, "called_numbers");
  const called_bingo = _.get(game_state, "called_bingo");
  const winners = _.get(game_state, "winners");
  const bad_bingos = _.get(game_state, "bad_bingos");
  const current_number = _.get(game_state, "current_number");
  const previous_number = _.get(game_state, "previous_number");
  const player = _.get(game_state, "player");
  const users = _.get(roomObj, "users");
  const current_player_details = users?.find(
    (user) => user.user_id === currentUser.userId
  );
  const current_player_board = _.find(player, {
    player_id: current_player_details?.player_id
  })?.board;
  const mobile_app = _.get(gameReducer, "mobile_app");
  const how_to_play = _.get(gameReducer, "how_to_play");
  const bingo_board = _.get(gameReducer, "bingo_board");
  const [countdown, set_countdown] = useState(timer);
  const [show_bingo_board, set_show_bingo_board] = useState(false);
  // const [board_clicked, set_board_clicked] = useState(initial_board);

  const handle_submit_bingo = () => {
    if (mobile_app) {
      const message = {
        action: "submit-bingo",
        board_clicked: bingo_board
      };
      window.parent.postMessage(message, "*");
    } else {
      const data = {
        action: "submit-bingo",
        roomId: (roomObj && roomObj.id) || "",
        board_clicked: bingo_board,
        playerId: current_player_details?.player_id || ""
      };
      Socket.sendMessage(data);
    }
  };

  useEffect(() => {
    const timer =
      countdown > 0 && setInterval(() => set_countdown(countdown - 1), 1000);
    return () => clearInterval(timer);
  }, [countdown]);

  useEffect(() => {
    if (status === "BingoCalled") {
      if (mobile_app) {
        const message = {
          action: "vibrate"
        };
        window.parent.postMessage(message, "*");
      } else {
        const canVibrate = window.navigator.vibrate;
        if (canVibrate) window.navigator.vibrate(500);
      }
    }
  }, [JSON.stringify(player), status]);

  useEffect(() => {
    set_countdown(timer);
  }, [JSON.stringify(status)]);

  useEffect(() => {
    if (!(status === "Playing" || status === "BingoCalled")) {
      set_show_bingo_board(false);
    }
    if (status === "Over" || status === "Joining") {
      props.set_bingo_board([
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0],
        [0, 0, 1, 0, 0],
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0]
      ]);
    }
  }, [status]);

  return (
    <div className={`bingo ${mobile_app ? "bingo-mobile-app" : "bingo-web"}`}>
      <div
        className={cx("bingo-content-wrapper", {
          "playing-overflow-scroll": status === "Playing"
        })}
      >
        {how_to_play && <HowToPlay set_how_to_play={props.set_how_to_play} />}
        {status === "Joining" && (
          <Joining users={users} gameParams={gameParams} />
        )}
        {(status === "Playing" ||
          status === "PrePlay" ||
          show_bingo_board) && (
          <Playing
            current_player_board={current_player_board}
            current_number={current_number}
            previous_number={previous_number}
            called_numbers={called_numbers}
            bingo_board={bingo_board}
            set_bingo_board={props.set_bingo_board}
            status={status}
            countdown={countdown}
            timed={timed}
            handle_submit_bingo={handle_submit_bingo}
            set_show_bingo_board={set_show_bingo_board}
            gameParams={gameParams}
          />
        )}
        {status === "BingoCalled" && !show_bingo_board && (
          <BingoCalled
            called_bingo={called_bingo}
            users={users}
            timed={timed}
            countdown={countdown}
            current_player_details={current_player_details}
            set_show_bingo_board={set_show_bingo_board}
            gameParams={gameParams}
          />
        )}
        {status === "BadBingo" && (
          <BadBingo
            bad_bingos={bad_bingos}
            users={users}
            timed={timed}
            countdown={countdown}
            gameParams={gameParams}
          />
        )}
        {status === "Over" && (
          <Over
            winners={winners}
            users={users}
            bad_bingos={bad_bingos}
            current_player_details={current_player_details}
            gameParams={gameParams}
          />
        )}
      </div>
      {mobile_app && <Footer />}
    </div>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer
});

const mapDispatchToProps = (dispatch) => {
  return {
    setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data)),
    set_how_to_play: (data) => dispatch(gameAction.how_to_play(data)),
    set_bingo_board: (data) => dispatch(gameAction.set_bingo_board(data))
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Bingo);
